import { getEmailSourceFormatForPart } from '../../email-conversion/source-formats/email-source-data-url'
export const CODE_ATTACHMENT_SUMMARY_PREFIX = 'Attachment upload:'

export function isGeneratedAttachmentSummary(text: string): boolean {
  return text.trimStart().startsWith(CODE_ATTACHMENT_SUMMARY_PREFIX)
}

/** Same code-file classification used by the chat UI and notification projection. */
export function isCodeAttachmentPart(part: {
  filename?: string
  mediaType?: string
  url?: string
}): boolean {
  const mediaType = part.mediaType?.toLowerCase() ?? ''
  const filename = part.filename?.toLowerCase() ?? ''
  return (
    getEmailSourceFormatForPart(part) !== undefined ||
    mediaType.includes('text/html') ||
    mediaType.includes('application/xhtml+xml') ||
    mediaType.includes('xml') ||
    /\.(?:html|htm|mjml|tsx|jsx|ts|js|css|json)$/.test(filename) ||
    /javascript|typescript|text\/plain|json|css/.test(mediaType) ||
    /^data:text\/html(?:;|,)/i.test(part.url ?? '')
  )
}
